import { ModalWindow } from '@cian/ui-kit';
import { FC, ReactNode } from 'react';

interface IHouseSubscriptionModalProps {
  onClose: VoidFunction;
  title?: string;
  content: ReactNode;
}

export const HouseSubscriptionModal: FC<IHouseSubscriptionModalProps> = ({ onClose, title, content }) => {
  return (
    <ModalWindow
      open
      onClose={onClose}
      title={title}
      width="100%"
      maxWidth={642}
      content={content}
      escape={false}
      size="M"
    />
  );
};
